import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import { ObraChecklistServicoCampos } from "../../../../domain/models/obra_checklist_servico_campos";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

/**
 * GenerateObraItensChecklistAreaCadastroColumnDefs
 */

type Props = {
  statusChecklistServico: number;
  obraChecklistServicoCampos: ObraChecklistServicoCampos | null;
  onActionEditar: (idInspecaoObra: number | null, openState: boolean) => void;
  onActionDeletar: (idInspecaoObra: number | null, openState: boolean) => void;
  onActionCopy: (idInspecaoObra: number | null, openState: boolean) => void;
  onActionReport: (idInspecaoObra: number) => void;
  onEnterInspecaoObra: (idInspecaoObra: number, openNewTab: boolean) => void;
};

export const GenerateObraItensChecklistAreaCadastroColumnDefs = ({
  statusChecklistServico,
  obraChecklistServicoCampos,
  onActionEditar,
  onActionDeletar,
  onActionCopy,
  onActionReport,
  onEnterInspecaoObra,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 0:
        return "VNI";
      case 1:
        return "E";
      case 2:
        return "A";
      case 3:
        return "VI";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 0:
        return "yellow";
      case 1:
        return "red";
      case 2:
        return "green";
      case 3:
        return "blue";
      default:
        return "gray";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Verificação Não Iniciada";
      case 1:
        return "Encerrada";
      case 2:
        return "Aprovado";
      case 3:
        return "Verificação Iniciada";
      default:
        return "?";
    }
  };

  const columns: GridColDef[] = [];

  if (obraChecklistServicoCampos) {
    if (obraChecklistServicoCampos.labelCampo1 && obraChecklistServicoCampos.labelCampo1.length > 0) {
      columns.push({
        field: 'campo1',
        filterable: false,
        headerName: obraChecklistServicoCampos.labelCampo1,
        flex: 1,
        minWidth: 100,
        sortable: false,
        renderCell: ({ value }) => {
          return (
            <div className="w-full h-full flex items-center text-xs">
              {value}
            </div>
          );
        }
      });
    }
    if (obraChecklistServicoCampos.labelCampo2 && obraChecklistServicoCampos.labelCampo2.length > 0) {
      columns.push({
        field: 'campo2',
        filterable: false,
        headerName: obraChecklistServicoCampos.labelCampo2,
        flex: 1,
        minWidth: 100,
        sortable: false,
        renderCell: ({ value }) => {
          return (
            <div className="w-full h-full flex items-center text-xs">
              {value}
            </div>
          );
        }
      });
    }
    if (obraChecklistServicoCampos.labelCampo3 && obraChecklistServicoCampos.labelCampo3.length > 0) {
      columns.push({
        field: 'campo3',
        filterable: false,
        headerName: obraChecklistServicoCampos.labelCampo3,
        flex: 1,
        minWidth: 100,
        sortable: false,
        renderCell: ({ value }) => {
          return (
            <div className="w-full h-full flex items-center text-xs">
              {value}
            </div>
          );
        }
      });
    }
    if (obraChecklistServicoCampos.labelCampo4 && obraChecklistServicoCampos.labelCampo4.length > 0) {
      columns.push({
        field: 'campo4',
        filterable: false,
        headerName: obraChecklistServicoCampos.labelCampo4,
        flex: 1,
        minWidth: 100,
        sortable: false,
        renderCell: ({ value }) => {
          return (
            <div className="w-full h-full flex items-center text-xs">
              {value}
            </div>
          );
        }
      });
    }
  }

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 50,
      width: 50,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center">
          <ItemStatus
            textSize="extraSmall"
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)}
          />
        </div>
      )
    },
    {
      field: "dataAbertura",
      filterable: false,
      headerName: "Data de Abertura",
      minWidth: 90,
      width: 90,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs">
            {value ? dayjs(value).format('DD/MM/YYYY') : null}
          </div>
        );
      }
    },
    {
      field: "dataEncerramento",
      filterable: false,
      headerName: "Data de Encerramento",
      minWidth: 100,
      width: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs">
            {value ? dayjs(value).format('DD/MM/YYYY') : null}
          </div>
        );
      }
    },
    ...columns,
    {
      field: "enter",
      filterable: false,
      headerName: "Itens de Checklist",
      sortable: false,
      minWidth: 100,
      width: 100,
      valueGetter: (_, row) => { return row['idInspecaoObra'] as number; },
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-xs">
            <Button
              onMouseDown={(e) => {
                if (e.button === 1) {
                  onEnterInspecaoObra(value, true);
                } else {
                  onEnterInspecaoObra(value, e.ctrlKey);
                }
                e.preventDefault();
              }}
              sx={{
                fontSize: 11,
                paddingX: '.4rem',
                paddingY: 0,
                background: '#e6e6e6',
                borderLeft: '.2rem solid #d84a38',
                borderRadius: 0,
                color: 'black',
                fontWeight: 'normal',
              }}>
              Itens
            </Button>
          </div>
        );
      },
    },
    {
      field: "totalItens",
      filterable: false,
      headerName: "Total Itens",
      flex: columns.length === 0 ? 1 : undefined,
      width: 50,
      minWidth: 50,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-xs">
            {value}
          </div>
        );
      }
    },
    {
      field: "totalNA",
      filterable: false,
      headerName: "Total (NA)",
      flex: columns.length === 0 ? 1 : undefined,
      width: 50,
      minWidth: 50,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-xs">
            {value}
          </div>
        );
      }
    },
    {
      field: "totalA",
      filterable: false,
      headerName: "Total (A)",
      flex: columns.length === 0 ? 1 : undefined,
      width: 50,
      minWidth: 50,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-xs">
            {value}
          </div>
        );
      }
    },
    {
      field: "totalR",
      filterable: false,
      headerName: "Total (R)",
      flex: columns.length === 0 ? 1 : undefined,
      width: 50,
      minWidth: 50,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-xs">
            {value}
          </div>
        );
      }
    },
    {
      field: "totalX",
      filterable: false,
      headerName: "Total (X)",
      flex: columns.length === 0 ? 1 : undefined,
      width: 50,
      minWidth: 50,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-xs">
            {value}
          </div>
        );
      }
    },
    {
      field: "totalRA",
      filterable: false,
      headerName: "Total (RA)",
      flex: columns.length === 0 ? 1 : undefined,
      width: 50,
      minWidth: 50,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-xs">
            {value}
          </div>
        );
      }
    },
    {
      field: "exportar",
      filterable: false,
      headerName: "Relatório",
      sortable: false,
      minWidth: 95,
      valueGetter: (_, row) => { return row['idInspecaoObra'] as number; },
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-xs">
            <Button
              onMouseDown={(e) => {
                onActionReport(value);
              }}
              sx={{
                fontSize: 11,
                paddingX: '.4rem',
                paddingY: 0,
                background: '#e6e6e6',
                borderLeft: '.2rem solid #35aa47',
                borderRadius: 0,
                color: 'black',
                fontWeight: 'normal',
              }}>
              Exportar
            </Button>
          </div>
        );
      },
    },
    {
      field: 'idInspecaoObra',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 120,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full">
            <div className="flex items-center justify-center w-full h-full">
              <IconButton
                disabled={statusChecklistServico === 1}
                onClick={() => onActionEditar(params.value, true)}>
                <DynamicIcon nameIcon="EditRounded" size={20} className="dark:text-white text-primary-green" />
              </IconButton>

              <IconButton
                disabled={statusChecklistServico === 1}
                onClick={() => onActionDeletar(params.value, true)}>
                <DynamicIcon nameIcon="DeleteForeverRounded" size={20} className="text-red-500" />
              </IconButton>

              <IconButton
                disabled={statusChecklistServico === 1}
                onClick={() => { onActionCopy(params.value, true) }}>
                <DynamicIcon nameIcon="ContentCopy" size={20} className="text-purple-500" />
              </IconButton>
            </div>
          </div>
        );
      }
    },
  ];
}